export const portfolios = [
  {
    id: '1',
    title: 'Atakum Kurupelit 3+1 Lüks Daire',
    price: 3200000,
    location: 'Atakum, Kurupelit Mahallesi',
    propertyType: 'Daire',
    authorityStatus: 'Açık',
    photo: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20apartment%20interior%20living%20room%20with%20large%20windows%20bright%20natural%20light%20minimalist%20design%20white%20walls%20wooden%20floors%20contemporary%20furniture%20high%20ceiling%20elegant%20decor%20warm%20tones&width=400&height=300&seq=1&orientation=landscape',
    photos: 8,
    documents: 3,
    viewCount: 45,
    createdAt: '2026-04-20',
    status: 'Aktif',
  },
  {
    id: '2',
    title: 'İlkadım Yalı Villa Özel Havuzlu',
    price: 7500000,
    location: 'İlkadım, Yalı Mahallesi',
    propertyType: 'Villa',
    authorityStatus: 'Özel',
    photo: 'https://readdy.ai/api/search-image?query=Luxury%20modern%20villa%20exterior%20with%20swimming%20pool%20garden%20landscape%20contemporary%20architecture%20white%20facade%20large%20glass%20windows%20palm%20trees%20sunset%20lighting%20elegant%20residential%20property&width=400&height=300&seq=2&orientation=landscape',
    photos: 15,
    documents: 5,
    viewCount: 128,
    createdAt: '2026-04-15',
    status: 'Aktif',
  },
  {
    id: '3',
    title: 'Tekkeköy Sanayi Dükkan 120m²',
    price: 15000,
    location: 'Tekkeköy, Sanayi Sitesi',
    propertyType: 'Dükkan',
    authorityStatus: 'Açık',
    photo: 'https://readdy.ai/api/search-image?query=Commercial%20shop%20storefront%20modern%20retail%20space%20glass%20windows%20clean%20interior%20white%20walls%20wooden%20flooring%20bright%20lighting%20empty%20commercial%20property%20professional%20real%20estate&width=400&height=300&seq=3&orientation=landscape',
    photos: 6,
    documents: 2,
    viewCount: 23,
    createdAt: '2026-04-22',
    status: 'Aktif',
  },
  {
    id: '4',
    title: 'Canik Sahil 2+1 Yeni Bina',
    price: 1850000,
    location: 'Canik, Sahil Mahallesi',
    propertyType: 'Daire',
    authorityStatus: 'Açık',
    photo: 'https://readdy.ai/api/search-image?query=Modern%20coastal%20apartment%20sea%20view%20balcony%20bright%20interior%20white%20walls%20blue%20accents%20contemporary%20furniture%20large%20windows%20natural%20light%20beach%20house%20style%20elegant&width=400&height=300&seq=4&orientation=landscape',
    photos: 10,
    documents: 4,
    viewCount: 67,
    createdAt: '2026-04-18',
    status: 'Aktif',
  },
  {
    id: '5',
    title: 'Bafra Merkez 500m² Arsa',
    price: 1200000,
    location: 'Bafra, Merkez',
    propertyType: 'Arsa',
    authorityStatus: 'Açık',
    photo: 'https://readdy.ai/api/search-image?query=Empty%20land%20plot%20green%20grass%20residential%20area%20clear%20sky%20development%20potential%20real%20estate%20investment%20property%20flat%20terrain%20surrounded%20by%20trees%20sunny%20day&width=400&height=300&seq=5&orientation=landscape',
    photos: 4,
    documents: 2,
    viewCount: 34,
    createdAt: '2026-04-10',
    status: 'Aktif',
  },
  {
    id: '6',
    title: 'Atakum Çarşı 1+1 Stüdyo',
    price: 950000,
    location: 'Atakum, Çarşı Mahallesi',
    propertyType: 'Daire',
    authorityStatus: 'Özel',
    photo: 'https://readdy.ai/api/search-image?query=Modern%20studio%20apartment%20compact%20living%20space%20open%20plan%20kitchen%20minimalist%20design%20white%20interior%20wooden%20floors%20large%20window%20natural%20light%20cozy%20efficient%20layout&width=400&height=300&seq=6&orientation=landscape',
    photos: 7,
    documents: 3,
    viewCount: 89,
    createdAt: '2026-04-25',
    status: 'Aktif',
  },
];

export const portfolioStats = {
  totalActive: 24,
  totalSold: 156,
  avgSaleDays: 45,
  totalValue: 48500000,
};